import React, { useState, useEffect, useRef } from "react";
import { Grid, IconButton, Paper } from "@material-ui/core";
import TableSkeleton from "../../../../StyledComponents/TableSkeleton";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  FormControl,
  Checkbox,
  TableBody,
  Typography,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { Delete } from "@material-ui/icons";
import "./style.css";
import EmptyData from "../../../../StyledComponents/Table/EmptyData";
import Heading from "../../../../StyledComponents/Heading/Heading";
import POAlertDialog from "./PoTableAlert";
import LinearProgress from "@mui/material/LinearProgress";
import Stack from "@mui/material/Stack";
import {
  DataSheetGrid,
  checkboxColumn,
  textColumn,
  keyColumn,
  intColumn,
  floatColumn,
  resizeColumn,
} from "react-datasheet-grid";
import "react-datasheet-grid/dist/style.css";

const useStyles = makeStyles({
  table: {
    // minWidth: 650,

    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
    },

    // tablebody: {
    //   "&.MuiTableRow-root:last-child td": {
    //     borderLeft: "1px solid #000",
    //   },
    // },
  },
  cellPadding: {
    padding: "0 !important",
  },
  inputStyle: {
    outline: "none",
    border: "none",
    // borderBottom: "1px solid black",
  },
  checkboxContainer: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: "5px 0px",
  },
  checkboxItem: {
    display: "flex",
    alignItems: "left",
    marginRight: "16px",
  },
  checkboxItemFirst: {
    marginLeft: 0,
  },
  "@media only screen and (max-width: 991px)": {
    checkboxContainer: {
      flexDirection: "column",
    },
    checkboxItem: {
      marginBottom: "8px",
      marginRight: 0,
    },
    checkboxItemFirst: {
      marginBottom: "8px",
    },
  },
});

function PoDetailTableLogistic({
  formState,
  setSelectedTotal,
  setFormState,
  disabled,
  deletee,
  Invoice_id,
  selectedRole,
  grn_No,
  isLogistics,
  copyOfPoDetail,
  setFormState_v1,
  searchWithPo,
  selected_PoRec,
  setSelected_PoRec,
  checkedBox,
  loading,
  edit,
  status,
}) {
  const tableData = [
    {
      AssetNumber: 0,
      BALANCE_QTY: 0,
      BALANCE_VAL: 0,
      COND_COUNT: "",
      COND_ST_NO: "",
      Currency: "",
      DIST_IND: "",
      DN_NO: 0,
      DOC_DATE: "",
      DOC_YEAR: "",
      DelivUnit: "",
      Dlvqty: "",
      INPUT_VAL: 0,
      INPUT_QTY: 0,
      INVOICE_QTY: 0,
      INVOICE_VAL: 0,
      KSCHL: "",
      ORDER_QTY: "",
      ORDER_UNIT: "",
      POItem: "",
      POItemText: "",
      PONumber: "",
      Plant: "",
      uniT_PRICE : "",
      Poqty: "",
      Quantity: "",
      RefDoc: "",
      RefDocIT: "",
      RefDocNo: "",
      RefDocNoLong: "",
      SEQ_NO: "",
      SHEET_ITEM: "",
      SHEET_NO: "",
      SO_ITEM: "",
      SO_NO: "",
      VText: "",
      Val_Gr_Loc: "",
      Val_Iv_Loc: "",
      Val_Loccur: "",
      Vendor_Code: "",
      Vendor_Name: "",
      DOC_DATE: "",
      invoice_Id: Number(Invoice_id),
      selected: false,
    },
  ];

  const classes = useStyles();
  const [cellState, setCellState] = useState("");
  // function to compare selected PO records GRN Amount with Invoice Amount so we can proceed

  const checkBal = (tempArray) => {
    let t = 0;
    let totalItems = tempArray.filter((data) => data?.selected == true);
    t = totalItems
      .map((balance) =>
        Number(balance?.inpuT_VAL?.toFixed(2) || balance?.INPUT_VAL?.toFixed(2))
      )
      .reduce((total, item) => total + item, 0);
    setSelectedTotal(t);
  };

  const addInput = () => {
    setFormState((formState) => ({
      ...formState,
      invoicePORef_List: [...formState.invoicePORef_List, tableData],
    }));
  };
  const deleteInput = (index) => {
    const filteredData = formState?.invoicePORef_List?.filter(
      (x, i) => i !== index
    );
    setFormState((formState) => ({
      ...formState,
      invoicePORef_List: filteredData,
    }));
    checkBal(filteredData);
  };

  const changeHandler = (e, index) => {
    const { name, value } = e.target;
    let tempArray = formState.invoicePORef_List;
    // for consumed quantity
    if (name === "Quantity") {
      //  GRN quantity
      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: Number(value),
        // [name]: Number(value).toFixed(0),
        INPUT_QTY:
          Number(value) -
          // Number(value).toFixed(0) -
          Number(tempArray[index].INVOICE_QTY),
        // Number(tempArray[index].INVOICE_QTY).toFixed(0),
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "INVOICE_QTY") {
      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: Number(value),
        // [name]: Number(value).toFixed(0),
        INPUT_QTY:
          Number(tempArray[index].Quantity) -
          // Number(tempArray[index].Quantity).toFixed(0) -
          Number(value),
        // Number(value).toFixed(0),
        // INPUT_VAL:Number(tempArray[index].Val_Loccur) - Number(tempArray[index].Val_Loccur)/Number( tempArray[index].Quantity)*Number(value)
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "Val_Loccur") {
      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: Number(value),
        INPUT_VAL: Number(
          (Number(value) - Number(tempArray[index].INVOICE_VAL))?.toFixed(2)
        ),
        // INVOICE_VAL: Number(value)/Number( tempArray[index].Quantity)*Number(tempArray[index].INVOICE_QTY)
      };

      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    } else if (name === "INVOICE_VAL") {
      // consumed Amount
      if (
        value <=
        (Number(tempArray[index].Val_Loccur) / // GRN amount
          Number(tempArray[index].Quantity)) * // GRN quantity
          Number(tempArray[index].INVOICE_QTY) //  consumed quantity
      ) {
        tempArray[index] = {
          ...formState.invoicePORef_List[index],
          [name]: Number(value),
          INPUT_VAL: Number(
            (Number(tempArray[index].Val_Loccur) - Number(value))?.toFixed(2)
          ),
        };

        setFormState((formState) => ({
          ...formState,
          invoicePORef_List: tempArray,
        }));
        checkBal(tempArray);
      }
    } else if (name === "INPUT_QTY") {
      // if (
      //   value <=
      //   Number(tempArray[index].Quantity) - Number(tempArray[index].INVOICE_QTY)
      // ) {
      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: Number(value),
        INPUT_VAL: Number(
          (
            (Number(tempArray[index].Val_Loccur) /
              Number(tempArray[index].Quantity)) *
            Number(value)
          )?.toFixed(2)
        ),
      };
      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
      // }
    } else if (name === "INPUT_VAL") {
      // if (
      //   value <=
      //   0.05 *
      //     ((Number(tempArray[index].Val_Loccur) /
      //       Number(tempArray[index].Quantity)) *
      //       Number(tempArray[index].INPUT_QTY)) +
      //     (Number(tempArray[index].Val_Loccur) /
      //       Number(tempArray[index].Quantity)) *
      //       Number(tempArray[index].INPUT_QTY)

      //   //  Number(tempArray[index].Val_Loccur) -
      //   //    Number(tempArray[index].INVOICE_VAL)
      // ) {
      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: Number(Number(value)?.toFixed(2)),
      };
      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));

      checkBal(tempArray);
      // }
    } else {
      tempArray[index] = {
        ...formState.invoicePORef_List[index],
        [name]: value,
      };
      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    }
  };

  const handleGridChange = (data, operation) => {
    let rowIndex = cellState?.cell?.row;
    let name = cellState?.cell?.colId;

    let tempArray = data;

    // for consumed quantity
    if (name === "selected") {
      if (tempArray[rowIndex]?.selected === true) {
        tempArray[rowIndex].selected = true;
        setFormState({
          ...formState,
          invoicePORef_List: tempArray,
        });
        checkBal(tempArray);
      } else {
        let tempArray = formState.invoicePORef_List;
        tempArray[rowIndex].selected = false;

        setFormState({
          ...formState,
          invoicePORef_List: tempArray,
        });
        checkBal(tempArray);
      }
    }
    if (name === "inpuT_QTY") {
      // if (
      //   value <=
      //   Number(tempArray[index].Quantity) - Number(tempArray[index].INVOICE_QTY)
      // ) {
      tempArray[rowIndex] = {
        ...formState.invoicePORef_List[rowIndex],
        inpuT_QTY: Number(tempArray[rowIndex].inpuT_QTY),
        inpuT_VAL: Number(
          (
            (Number(tempArray[rowIndex].val_Loccur) /
              Number(tempArray[rowIndex].quantity)) *
            Number(tempArray[rowIndex].inpuT_QTY)
          )?.toFixed(2)
        ),
      };
      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
      // }
    } else {
      setFormState((formState) => ({
        ...formState,
        invoicePORef_List: tempArray,
      }));
      checkBal(tempArray);
    }
  };

  const handleDelete = (rowIndex) => {
    // Make a copy of the current invoicePORef_List array
    const updatedList = [...formState.invoicePORef_List];

    // Remove the item at the specified index
    updatedList.splice(rowIndex, 1);

    // Update the formState with the updated list
    setFormState((formState) => ({
      ...formState,
      invoicePORef_List: updatedList,
    }));

    // Recalculate the total after deletion
    checkBal(updatedList);
  };

  const selectRec = (e, index) => {
    if (e.target.checked === true) {
      let tempArray = formState.invoicePORef_List;

      tempArray[index].selected = true;
      setFormState({
        ...formState,
        invoicePORef_List: tempArray,
      });
      checkBal(tempArray);
    } else {
      let tempArray = formState.invoicePORef_List;
      tempArray[index].selected = false;

      setFormState({
        ...formState,
        invoicePORef_List: tempArray,
      });
      checkBal(tempArray);
    }

    // if (e.target.checked == true) {
    //   setSelected_PoRec((selected_PoRec) => ({
    //     ...selected_PoRec,
    //     invoicePORef_List: [...selected_PoRec.invoicePORef_List, item],
    //   }));
    // } else {
    //   const filteredData = selected_PoRec?.invoicePORef_List?.filter(
    //     (x) => x !== item
    //   );
    //   setSelected_PoRec((selected_PoRec) => ({
    //     ...selected_PoRec,
    //     invoicePORef_List: filteredData,
    //   }));
    // }
  };
  const [isSelectAll, setIsSelectAll] = useState(false);
  const selectAll = (e) => {
    let tempArray = formState.invoicePORef_List;
    for (let index = 0; index < formState?.invoicePORef_List?.length; index++) {
      // const element = formState?.invoicePORef_List[index];
      tempArray[index].selected = e.target.checked;
    }
    setFormState({
      ...formState,
      invoicePORef_List: tempArray,
    });
    checkBal(tempArray);
    setIsSelectAll(e.target.checked);
  };

  useEffect(() => {
    let filtered = [];
    let grn = [];
    if (
      selectedRole.roleName === "IR" &&
      copyOfPoDetail?.copyInvoicePORef_List?.length > 0 &&
      !isLogistics &&
      grn_No != null
    ) {
      grn = grn_No?.replace(/\s+/g, "");
      grn = grn?.split(",");
      for (let i = 0; i < copyOfPoDetail?.copyInvoicePORef_List?.length; i++) {
        const item = copyOfPoDetail?.copyInvoicePORef_List[i];
        grn?.map((data) => {
          if (item?.RefDoc?.toLowerCase().includes(data?.toLowerCase())) {
            filtered.push(item);
          }
        });
      }

      setFormState((temp_ActualPoDetail) => ({
        ...temp_ActualPoDetail,
        invoicePORef_List: filtered,
      }));
      checkBal(filtered);

      // these if statments are for handle data in fields (PO and DN)
      if (!searchWithPo && filtered[0]?.DN_NO) {
        setFormState_v1((formState) => ({
          ...formState,
          pO_No: filtered[0]?.PONumber || "",
          delv_Note_No: filtered[0]?.DN_NO,
        }));
      }
      if (!searchWithPo && !filtered[0]?.DN_NO) {
        setFormState_v1((formState) => ({
          ...formState,
          pO_No: "",
        }));
      }

      if (searchWithPo && filtered[0]?.PONumber) {
        setFormState_v1((formState) => ({
          ...formState,
          pO_No: filtered[0]?.PONumber,
          delv_Note_No: filtered[0]?.DN_NO || "",
        }));
      }
      if (searchWithPo && !filtered[0]?.PONumber) {
        setFormState_v1((formState) => ({
          ...formState,
          delv_Note_No: "",
        }));
      }
    }
  }, [copyOfPoDetail?.copyInvoicePORef_List, grn_No]);

  // const AmountCell = React.memo(
  //   ({ active, rowData, setRowData,focus  }) => {
  //     const inputRef = useRef(null);

  //     useEffect(() => {
  //       if (focus) {
  //         inputRef.current?.focus();
  //       } else {
  //         inputRef.current?.blur();
  //       }
  //     }, [focus]);

  //     return (
  //       <TextField
  //       type="number"
  //       // name="amount"
  //       // size="small"
  //       // value={rowData?.amount}
  //       sx={{
  //         "& legend": { display: "none" },
  //         "& fieldset": { top: 0 },
  //       }}
  //       variant="standard"
  //       required
  //       value={rowData}
  //       min={0}
  //       InputProps={{
  //         inputProps: { min: 0, step:"0.01" },
  //         disableUnderline: true,
  //       }}
  //       onChange={(e) => setRowData(e.target.value)}

  //     />
  //     )
  //   }
  // )
  // const AmountCell = React.memo(
  //   ({ active, rowData, setRowData, focus }) => {
  //     const inputRef = useRef(null);

  //     useEffect(() => {
  //       if (focus && inputRef.current) {
  //         inputRef.current.focus();
  //       }
  //     }, [focus]);

  //     const handleInputChange = (e) => {
  //       setRowData(e.target.value);
  //     };

  //     return (
  //       <TextField
  //         type="number"
  //         sx={{
  //           "& legend": { display: "none" },
  //           "& fieldset": { top: 0 },
  //         }}
  //         variant="standard"
  //         required
  //         value={rowData}
  //         min={0}
  //         InputProps={{
  //           inputProps: { min: 0, step: "0.01" },
  //         }}
  //         onChange={handleInputChange}
  //         inputRef={inputRef} // Pass the ref to the input element
  //       />
  //     );
  //   }
  // );

  // const intColumn = {
  //   component: AmountCell,
  //   deleteValue: () => '',
  //   disableKeys: true,
  //   keepFocus: true,
  //   copyValue: ({ rowData }) => rowData,
  //   pasteValue: ({ value }) => value,
  // }
  const [columns, setColumns] = useState([
    {
      ...keyColumn("selected", checkboxColumn),
      title: "",
      // disabled: ({ disabled }) => (disabled ? true : false),
      disabled: disabled,
    },

    {
      // ...keyColumn((disabled && editable === "true") ? "poItem" : "POItem"  , textColumn),
      // ...keyColumn(("poItem" || "POItem"  )   , textColumn),
      ...keyColumn("poItem" || "POItem", textColumn),
      title: "Item #",
      disabled: true,
      minWidth: 160,
      // disabled: ({ disabled }) => (disabled ? true : false),
    },
    {
      // ...keyColumn((disabled || editable === "true") ? "poNumber" : "PONumber"  , textColumn),
      ...keyColumn("poNumber" || "PONumber", textColumn),

      title: "PO Number",
      width: 160,
      disabled: true,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },

    {
      // ...keyColumn("RefDoc", textColumn),
      ...keyColumn("refDoc" || "RefDoc", textColumn),

      title: "GRN No",
      width: 160,
      disabled: true,

      // disabled: ({ disabled }) => (disabled ? true : false),

      // grow: 2,
    },
    {
      // ...keyColumn("Quantity", textColumn),
      ...keyColumn("quantity" || "Quantity", textColumn),

      title: "GRN Quantity",
      width: 160,
      // disabled: ({ disabled }) => (disabled ? true : false),
      disabled: true,

      // grow: 2,
    },
    {
      // ...keyColumn("Val_Loccur", textColumn),
      ...keyColumn("val_Loccur" || "Val_Loccur", textColumn),

      title: "GRN Amount",
      width: 160,
      // grow: 4,
      // disabled: ({ disabled }) => (disabled ? true : false),
      disabled: true,
    },
    {
      // ...keyColumn("INVOICE_QTY", textColumn),
      ...keyColumn("invoicE_QTY" || "INVOICE_QTY", textColumn),

      title: "Consumed Quantity",
      width: 160,
      // grow: 3,
      // disabled: ({ disabled }) => (disabled ? true : false),
      disabled: true,
    },
    {
      // ...keyColumn("INVOICE_VAL", textColumn),
      ...keyColumn("invoicE_VAL" || "INVOICE_VAL", textColumn),

      title: "Consumed Amount",
      width: 160,
      // grow: 3,
      disabled: true,
    },
    {
      // ...keyColumn("INPUT_QTY", textColumn),
      ...keyColumn("inpuT_QTY" || "INPUT_QTY", floatColumn),

      title: " Invoice Qty",
      width: 160,
      // grow: 2,
      disabled: ({ disabled }) => (disabled ? true : false),
      // disabled: disabled,
    },
     {
      ...keyColumn("uniT_PRICE", textColumn),
      title: "Unit Price",
      disabled: true,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },
    {
      // ...keyColumn("INPUT_VAL", textColumn),
      ...keyColumn("inpuT_VAL" || "INPUT_VAL", floatColumn),

      title: "Invoice Amt",
      width: 160,
      grow: 2,
      disabled: ({ disabled }) => (disabled ? true : false),
      // disabled: disabled,
    },
    {
      // ...keyColumn("Currency", textColumn),
      ...keyColumn("currency" || "Currency", textColumn),

      title: "Currency",
      // width: 150,
      disabled: true,

      grow: 2,
      // disabled: ({ disabled }) => (disabled ? true : false),
    },
    {
      // ...keyColumn("POItemText", textColumn),
      ...keyColumn("poItemText" || "POItemText", textColumn),

      title: " PO Text",
      disabled: true,
      minWidth: 300,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },
    {
      // ...keyColumn("Plant", textColumn),
      ...keyColumn("plant" || "Plant", textColumn),

      title: "Plant",
      disabled: true,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },

   


    {
      // ...keyColumn("DN_NO", textColumn),
      ...keyColumn("dN_NO" || "DN_NO", textColumn),

      title: "Delivery Note",
      disabled: true,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },

    {
      // ...keyColumn("AssetNumber", textColumn),
      ...keyColumn("assetNumber" || "AssetNumber", textColumn),

      title: "Asset No",
      disabled: true,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },

    {
      // ...keyColumn("VText", textColumn),
      ...keyColumn("vText" || "VText", textColumn),

      title: "Text",
      disabled: true,

      // disabled: ({ disabled }) => (disabled ? true : false),
    },

    // will be called to handle pasting. Because we chose to copy the label, we have to transform it back to a value on pasting.
  ]);
  return (
    <Grid container style={{ margin: "15px 0px" }}>
      <Grid item xs={12} sm={12} md={12} lg={12} style={{ width: "0" }}>
        {!selectedRole.roleName === "IR" ||
        !selectedRole.roleName === "Logistics" ? (
          <Heading title="PO Details" />
        ) : null}
        {formState.invoicePORef_List?.length > 0 && (
          <div className={classes.checkboxContainer}>
            <input
              type="checkbox"
              checked={isSelectAll}
              onChange={(e) => {
                selectAll(e);
              }}
              className={classes.checkboxItemFirst}
            />
            <Typography className={classes.checkboxItem}>Select All</Typography>
          </div>
        )}
        {/*<TableContainer
          className="scrollable"
          style={{
            maxHeight: "400px",
            minHeight: "100px",
            overflowY: "auto",
          }}
        >
          <Table
            className={classes.table}
            aria-label="a dense table"
            // padding="normal"
            size="small"
          >
            <TableHead style={{ position: "sticky", top: 0, zIndex: "1" }}>
              <TableRow sx={{ backgroundColor: "#EFF2F4" }}>
                <TableCell
                  align="center"
                  sx={{ fontWeight: "bold", color: "#031C30" }}
                >
                  #
                </TableCell>
                {checkedBox && (
                  <TableCell
                    sx={{ fontWeight: "bold", color: "#031C30" }}
                  ></TableCell>
                )}
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Item #
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  PO Number
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  GRN No
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  GRN Quantity
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  GRN Amount
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Consumed Quantity
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Consumed Amount
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Invoice Qty
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Invoice Amt
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Currency
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  PO Text
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Plant
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Delivery Note
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Asset No.
                </TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "#031C30" }}>
                  Text
                </TableCell>
                {deletee && (
                  <TableCell
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                      color: "#031C30",
                    }}
                  >
                    Action
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {formState.invoicePORef_List?.length > 0 &&
                formState.invoicePORef_List?.map((item, index) => {
                  return (
                    <TableRow
                      sx={{
                        backgroundColor: item?.selected && "rgb(240,240,240)",
                      }}
                      key={index}
                      // sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell
                        style={{ color: "black" }}
                        className={classes.cellPadding}
                        align="center"
                        scope="row"
                      >
                        {index + 1}
                        {item.selected}
                      </TableCell>
                      {checkedBox && (
                        <TableCell>
                        
                          <input
                            type="checkbox"
                            checked={item?.selected ? true : false}
                            onChange={(e) => {
                              selectRec(e, index);
                            }}
                          />
                        </TableCell>
                      )}
                      <TableCell>
                        <input
                          type="number"
                          size="small"
                          className={classes.inputStyle}
                          style={{
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          variant="standard"
                          name="POItem"
                          value={item?.poItem || item?.POItem}
                          min="0"
                          step="0.01"
                          disabled={disabled}
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          className={classes.inputStyle}
                          style={{
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          type="number"
                          size="small"
                          variant="standard"
                          name="PONumber"
                          value={item?.poNumber || item?.PONumber}
                          disabled={disabled}
                          min="0"
                          step="0.01"
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>

                      <TableCell>
                        <input
                          className={classes.inputStyle}
                          style={{
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          type="number"
                          size="small"
                          variant="standard"
                          name="RefDoc"
                          value={item?.refDoc || item?.RefDoc || 0}
                          disabled={disabled}
                          min="0"
                          step="0.01"
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          className={classes.inputStyle}
                          style={{
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          type="number"
                          size="small"
                          variant="standard"
                          name="Quantity"
                          value={item?.quantity || item?.Quantity}
                          disabled={disabled}
                          min="0"
                          step="0.00001"
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>

                      <TableCell>
                        <input
                          className={classes.inputStyle}
                          style={{
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          type="number"
                          size="small"
                          variant="standard"
                          name="Val_Loccur"
                          value={item?.val_Loccur || item?.Val_Loccur}
                          disabled={disabled}
                          min="0"
                          step="0.00001"
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          className={classes.inputStyle}
                          style={{
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          type="number"
                          size="small"
                          variant="standard"
                          name="INVOICE_QTY"
                          value={item?.invoicE_QTY || item?.INVOICE_QTY}
                          disabled={disabled}
                          min="0"
                          step="0.00001"
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>

                      <TableCell>
                        <input
                          className={classes.inputStyle}
                          style={{
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          type="number"
                          size="small"
                          variant="standard"
                          name="INVOICE_VAL"
                          value={item?.invoicE_VAL || item?.INVOICE_VAL}
                          disabled={disabled}
                          min="0"
                          step="0.00001"
                          onChange={(event) => {
                            changeHandler(event, index);
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          className={classes.inputStyle}
                          style={{
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                            width: "100px",
                          }}
                          type="number"
                          size="small"
                          variant="standard"
                          name="INPUT_QTY"
                          value={item?.inpuT_QTY || item?.INPUT_QTY || 0}
                          disabled={disabled}
                          step="0.00001"
                       
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>

                      <TableCell>
                        <input
                          className={classes.inputStyle}
                          style={{
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                            width: "100px",
                          }}
                          type="number"
                          size="small"
                          variant="standard"
                          name="INPUT_VAL"
                          value={item?.inpuT_VAL || item?.INPUT_VAL || 0}
                          disabled={disabled}
                          step="0.00001"
                          // min={
                          //   item?.selected
                          //     ? (
                          //         (Number(
                          //           item?.val_Loccur || item?.Val_Loccur
                          //         ) /
                          //           Number(item?.quantity || item?.Quantity)) *
                          //           Number(item?.inpuT_QTY || item?.INPUT_QTY) -
                          //         (Number(
                          //           item?.val_Loccur || item?.Val_Loccur
                          //         ) /
                          //           Number(item?.quantity || item?.Quantity)) *
                          //           Number(item?.inpuT_QTY || item?.INPUT_QTY) *
                          //           0.05
                          //       ).toFixed(0)
                          //     : 0
                          // }
                          // max={(
                          //   (Number(item?.val_Loccur || item?.Val_Loccur) /
                          //     Number(item?.quantity || item?.Quantity)) *
                          //     Number(item?.inpuT_QTY || item?.INPUT_QTY) +
                          //   (Number(item?.val_Loccur || item?.Val_Loccur) /
                          //     Number(item?.quantity || item?.Quantity)) *
                          //     Number(item?.inpuT_QTY || item?.INPUT_QTY) *
                          //     0.05
                          // ).toFixed(0)}
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          className={classes.inputStyle}
                          style={{
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          type="text"
                          size="small"
                          variant="standard"
                          name="Currency"
                          value={item?.currency || item?.Currency}
                          disabled={disabled}
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          className={classes.inputStyle}
                          style={{
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          type="text"
                          size="small"
                          variant="standard"
                          name="POItemText"
                          value={item?.poItemText || item?.POItemText}
                          disabled={disabled}
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          className={classes.inputStyle}
                          style={{
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          type="number"
                          size="small"
                          variant="standard"
                          name="Plant"
                          value={item?.plant || item?.Plant || 0}
                          disabled={disabled}
                          step="0.01"
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          className={classes.inputStyle}
                          style={{
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          type="number"
                          size="small"
                          variant="standard"
                          name="DN_NO "
                          value={item?.dN_NO || item?.DN_NO || 0}
                          disabled={disabled}
                          step="0.01"
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          className={classes.inputStyle}
                          style={{
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          type="number"
                          size="small"
                          variant="standard"
                          name="AssetNumber"
                          value={item?.assetNumber || item?.AssetNumber || 0}
                          disabled={disabled}
                          step="0.01"
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          className={classes.inputStyle}
                          style={{
                            backgroundColor:
                              item?.selected && "rgb(240,240,240)",
                          }}
                          type="text"
                          size="small"
                          variant="standard"
                          name="VText"
                          value={item?.vText || item?.VText}
                          disabled={disabled}
                          onChange={(event) => changeHandler(event, index)}
                        />
                      </TableCell>
                      {deletee && (
                        <TableCell
                          align="center"
                          className={classes.cellPadding}
                        >
                          <IconButton
                            size="small"
                            onClick={() => {
                              deleteInput(index);
                            }}
                          >
                            <Delete color="error" fontSize="small" />
                          </IconButton>
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
            </TableBody>
            {loading && <TableSkeleton noOfColumns={18} noOfLines={3} />}
          </Table>
          {formState.invoicePORef_List?.length === 0 && !loading ? (
            <EmptyData />
          ) : (
            ""
          )}
          </TableContainer>
          */}

        {formState.invoicePORef_List?.length === 0 && !loading ? (
          <EmptyData />
        ) : loading ? (
          <>
            <Stack sx={{ width: "100%", color: "grey.500" }} spacing={2}>
              <LinearProgress color="info" />
              <LinearProgress color="info" />
              <LinearProgress color="info" />
            </Stack>
          </>
        ) : (
          <DataSheetGrid
            style={{
              "--dsg-header-text-color": "#031C30",
            }}
            value={[
              ...formState?.invoicePORef_List?.map((item) => {
                return {
                  ...item,
                  Currency:'PKR',
                  currency:'PKR',
                  INPUT_VAL: Number(Number(item?.INPUT_VAL)?.toFixed(2)),
                };
              }),
            ]}
            // value={formState?.invoicePORef_List}
            onChange={handleGridChange}
            columns={columns}
            //  lockRows={(disabled || formState.invoicePORef_List.length === 0) ? true: false}
            lockRows={true}
            onActiveCellChange={(res) => {
              setCellState(res);
            }}

            // onDelete={handleDelete}
          />
        )}

        {/* {!disabled && (
          <Box display="flex" justifyContent={"flex-end"} mt={2}>
            <Button
              color="secondary"
              variant="contained"
              onClick={addInput}
              style={{ display: edit == "false" ? "none" : "" }}
            >
              Add New Row
            </Button>
          </Box>
       )}*/}
      </Grid>
    </Grid>
  );
}

export default React.memo(PoDetailTableLogistic);
